const graphAPIEndpoints = {
  ethereum: {
    metaverse: null,
    shibaswap: 'https://squidapi.shib.io/graphql?service=shibaswap/eth-exchange',
  },
  puppynet: {
    metaverse: null,
    shibaswap: 'https://squidapi.shib.io/graphql?service=shibaswap/eth-exchange',
  },
  shibarium: {
    metaverse: null,
    shibaswap: 'https://squidapi.shib.io/graphql?service=shibaswap/eth-exchange',
  },
  multichain: {
    metaverse: 'https://shib.squids.live/shib-metaverse@main/api/graphql',
  },
};

export default graphAPIEndpoints;
